<mat-dialog-content class="dialog-content">
  <section>
    @if (!msForm?.length) {
      <mds-loader></mds-loader>
    }
    @if (msForm) {
      <h3 class="title">Azure AD</h3>
      <form (keydown.enter)="$event.preventDefault()" autocomplete="off">
        @for (field of msForm; track field) {
          <div>
            @if (field.type !== 'list') {
              <div class="layout form-field">
                <mat-label>{{ field.label }}</mat-label>
                <mat-form-field appearance="outline">
                  <input [(ngModel)]="field.value" [name]="field.key" [type]="field.type" autocomplete="off" matInput />
                </mat-form-field>
              </div>
            }
            @if (field.type === 'list') {
              <div class="layout form-field">
                <mat-label>{{ field.label }}</mat-label>
                <mat-form-field appearance="outline">
                  <mat-chip-grid #chipList>
                    @for (tag of field.value; track tag) {
                      <mat-chip-row (removed)="remove(tag, field.value)" [removable]="true">
                        {{ tag }}
                        <mat-icon aria-label="Remove" matChipRemove>cancel</mat-icon>
                      </mat-chip-row>
                    }
                    <input
                      #tagInput
                      (matChipInputTokenEnd)="add($event, field.value)"
                      [formControl]="tagCtrl"
                      [matChipInputFor]="chipList"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [name]="field.key"
                      matInput
                      type="text"
                      />
                  </mat-chip-grid>
                </mat-form-field>
              </div>
            }
          </div>
        }
      </form>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="footer">
  <mds-button (click)="ssoSubmit()" aria-label="Update" role="button" type="primary">Update</mds-button>
</mat-dialog-actions>
